<template>
	<div class="header--content--wrapper-buttons">
        <button v-on:click="cancelButton()" v-if="cancel_button" class="btn btn-secondary">{{cancel_button_label}}</button>
        <button v-on:click="secondaryButton()" v-if="secondary_button" class="btn btn-outline-primary">{{secondary_button_label}}</button>
        <button v-on:click="primaryButton()" v-if="primary_button" class="btn btn-primary">{{primary_button_label}}</button>
    </div>
</template>

<script>
    export default {
        name: "SaveEditCancelButtons",
        props: {
            cancel_button: {
                type: Boolean,
                default: false
            },
            cancel_button_label: {
                type: String,
                default: 'Cancel'
            },
            primary_button: {
                type: Boolean,
                default: false
            },
            primary_button_label: {
                type: String,
                default: 'Save'
            },
            secondary_button: {
                type: Boolean,
                default: false
            },
            secondary_button_label: {
                type: String,
                default: ''
            }
        },

        methods: {
            cancelButton(){
                this.$emit('cancel');
                window.dispatchEvent(new CustomEvent('LAYOUT:cancel_button'));
            },
            primaryButton(){
                this.$emit('primary');
                window.dispatchEvent(new CustomEvent('LAYOUT:primary_button'));
            },
            secondaryButton(){
                this.$emit('secondary');
                window.dispatchEvent(new CustomEvent('LAYOUT:secondary_button'));
            }
        }
    }
</script>
